module.exports = __webpack_public_path__ + "img/shortcut.7d2ea7e7.svg";